import { render, staticRenderFns } from "./DialogClassSetup.vue?vue&type=template&id=7de989bc"
import script from "./DialogClassSetup.vue?vue&type=script&lang=js"
export * from "./DialogClassSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports